
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 23.687c-.4 0-.776-.155-1.059-.437L3.22 15.529a.752.752 0 01.53-1.281c.2 0 .389.078.53.22l7.72 7.72 7.719-7.72a.744.744 0 011.06 0 .752.752 0 010 1.061l-7.72 7.72a1.485 1.485 0 01-1.059.438zM3.75 9.749a.743.743 0 01-.53-.22C3.078 9.388 3 9.2 3 8.999s.078-.389.22-.53l7.72-7.72A1.487 1.487 0 0112 .31c.401 0 .777.156 1.059.438l7.721 7.721c.142.141.22.33.22.53s-.078.389-.22.53a.749.749 0 01-1.06 0L12 1.809l-7.72 7.72a.743.743 0 01-.53.22z"}})])
          )
        }
      }
    